module.exports = __webpack_public_path__ + "img/sodam_thum03.36c46b47.jpeg";